import * as React from "react";
const PenSvg = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 22 5.5 7.5 13 6l5 5-1.5 7.5zm0 0 7.586-7.586M19 12l-7-7 3-3 7 7zm-8-1a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
      stroke="#16a34a"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PenSvg;
